// Filter option constants shared by UnifiedFilter

export const TIME_RANGE_OPTIONS = [
  { value: '24h', label: 'Last 24h' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
];

export const REGION_OPTIONS = [
  { value: 'all', label: 'All Regions' },
  { value: 'north', label: 'North' },
  { value: 'south', label: 'South' },
  { value: 'east', label: 'East' },
  { value: 'west', label: 'West' },
];

export const CATEGORY_OPTIONS = [
  'All',
  'Economy',
  'Education',
  'Healthcare',
  'Infrastructure',
  'Security',
];

export const ELECTION_TYPE_OPTIONS = [
  { value: 'presidential', label: 'Presidential' },
  { value: 'gubernatorial', label: 'Gubernatorial' },
  { value: 'senate', label: 'Senate' },
  { value: 'house', label: 'House of Reps' },
  { value: 'state-assembly', label: 'State Assembly' },
];

export const VOTER_STATUS_OPTIONS = [
  { value: 'all', label: 'All Personas' },
  { value: 'active', label: 'Active' },
  { value: 'new', label: 'New' },
];
